import React from "react";
import { Inline, TextLink, Box, Text } from "@origin-digital/ods-core";

export const FooterContent = () => {
  return (
    <Box
      padding={["medium", "large"]}
      display="flex"
      justifyContent={{
        xs: "center",
        md: "space-between",
      }}
      alignItems="center"
      flexDirection={{
        xs: "column",
        md: "row",
      }}
      style={{
        minHeight: "68px",
      }}
    >
      <Inline space="medium" alignX="center">
        <Text variant="body-small" tone="neutralLight">
          <TextLink
            href="https://www.originenergy.com.au/privacy/"
            target="_blank"
          >
            Privacy
          </TextLink>
        </Text>
        <Text variant="body-small" tone="neutralLight">
          <TextLink
            href="https://www.originenergy.com.au/terms-of-use/"
            target="_blank"
          >
            Terms of Use
          </TextLink>
        </Text>

        <Text variant="body-small" tone="neutralLight">
          <TextLink
            href="https://www.originenergy.com.au/terms-and-conditions/"
            target="_blank"
          >
            Terms and Conditions
          </TextLink>
        </Text>
      </Inline>
      <Box
        marginTop={{
          xs: "medium",
          md: "none",
        }}
      >
        <Text variant="body-small" tone="neutralLight" align="center">
          © {new Date().getFullYear()} Origin Energy Limited
        </Text>
      </Box>
    </Box>
  );
};
